var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Who is Responsible for their Construction?"}},[_c('div',{staticClass:"flex-1"},[_c('buyer-seller-split',{attrs:{"field":"roads_who_responsible","value":_vm.commercial.roads_who_responsible,"read_only":_vm.read_only}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }